import {lazy} from './lang.js';
import {decisions} from './tgenerate.js';
import {
    applyToLeaf,
    applyRule,
    before,
    after,
    ANY,
    when ,
    otherwise,
    ACCENT,
    FLAM,
    STACCATO,
    DOUBLE,
    REST,
    LEGATO,
    PIANO,
    PIANISSIMO
} from './trules.js';
import {getCycleString, getLeafString, dash, dot} from '../tidal/parser.js';
import {tparse} from './tidal.js';
import {concat} from './list.js';
import {t_leaf, t_swap, t_transform_leaf, t_map} from './tlist.js';

const EMPTY = [];

window.lazies = 0;
window.nolazies = 0;
// comppliment is a "complimentary pattern" that we will accennt against
// ensuring no accents fall on the same point. you can
// also write rules against this complimentary pattern
// for example, 

// helper func for calling w/o seed
export const apply_rules = (p, ruleBook, compliment, complimentRuleBook) =>
    jaki_accent(p, 1, ruleBook, compliment, complimentRuleBook);

export const jaki_accent = (p, seed=0, ruleBook, compliment, complimentRuleBook) => {

    let lastPattern = undefined;
    let lastSeed = undefined;
    let lastRuleBook = undefined;
    let lazyValue = undefined;
    let lastCRules, lastCompliment;

    const isDot = (l) => l.type && l.type.type === '.';
    const isDash = (l,v) => l.type && l.type.type === '-' &&
          l.type.value === v;
    

    return (...args) => {
        let _p = lazy(p, ...args);
        let _compliment = lazy(compliment, ...args);
        let _seed = lazy(seed, ...args);
        let _rules = lazy(ruleBook, ...args);
        let c_rules = lazy(complimentRuleBook, ...args);

        // set all the rules counters to 0
        _rules.forEach(r => r.counter = 0);
        if (c_rules) {
            c_rules.forEach(r => r.counter = 0);
        }

        if (_p === lastPattern && lastSeed === _seed && lastRuleBook === _rules &&
            lastCRules === c_rules && lastCompliment === _compliment) {
            window.lazies++;
            return lazyValue;
        } 

        lastPattern = _p;

        lastSeed = _seed;
        lastCompliment = _compliment;
        lastCRules = c_rules;
        lastRuleBook = _rules;
        _compliment = _compliment && _compliment.flat(16);

        if (lastPattern === undefined) {
            return EMPTY;
        }
        
        let {
            decide
        } = decisions(_seed)(...args);
        
        let prev = undefined;
        let list = [];

        // keeps track of what # leaf we're on
        let nth=0;

        // keeps track of delayed rules to apply
        let delays = [];

        // returns the previous and current complimentary pattern's leafs
        const c_prev = () => _compliment && _compliment[(nth - 1)%_compliment.length];
        const c_current = () => _compliment && _compliment[nth % _compliment.length];
        const setCurrentLeaf = (leaf) => list[list.length - 1] = leaf;

        let currentFigure = undefined;
        let figureCount = 0;
        let termOtherwise = false;
        let nthFigure = 0;
        let totalFigures = countFigures(_p);

        const runTerm = (leaf) => {
            if (Array.isArray(leaf)) {
                // Might not be a leaf, but instead an array
                return handleArrayLeaf(leaf);
            }

            if (leaf.figureId !== currentFigure) {
                figureCount = 0;
                currentFigure = leaf.figureId;
                if (nth !== 0) {
                    nthFigure++;
                }
            }


            leaf.rules = [];

            // Keeps track if any rules have been applied succesfully.
            // Is used by the "otherwise" condition
            termOtherwise = false;

            // Expressions like when(ACCENT).later(4).always(REST) essentially
            // puts a "delay" on an action.
            // We eventually run these "delayed" actions here
            leaf = applyDelaysToLeaf(leaf);

            // a leaf will satisfy the "when" condition if it
            // is occuring "right now". For instance when(ACCENT)
            // occurs when there is an accent on this current leaf.
            let rules = getRulesForLeaf(leaf, when);

            // from these (if any) rules, we transform the leaf, based
            // on the predicated actions dictated in the "rule book" (i.e. the rules
            // passed by the user).
            leaf = rules.reduce(
                (leaf, rule) => applyRuleToLeaf(rule, leaf, _rules, figureCount), leaf);

            if (prev) {
                // based on the previous leaf
                let prevRules = getRulesForLeaf(prev, after);
                leaf = prevRules.reduce(
                    (leaf, rule) => applyRuleToLeaf(rule, leaf, _rules, figureCount), leaf);

                // We might've added an accent to THIS leaf. this could
                // inadvertently trigger a new rule to be applied so we must check
                rules = getRulesForLeaf(leaf, when);
                leaf = rules.reduce(
                    (leaf, rule) => applyRuleToLeaf(rule, leaf, _rules, figureCount, false, true), leaf);

                list.push(leaf);

                // now due to these rules being applied, it might
                // happen that the leaf triggers a "before condition"
                // for example if we added an ACCENT, and have a before(ACCENT).always(STACCATO)
                // we want to apply that staccato now

                let beforeRules = getRulesForLeaf(leaf, before);
                list[list.length - 2] = beforeRules.reduce(
                    (_leaf, rule) => applyRuleToLeaf(
                        rule, _leaf, _rules, figureCount, before), prev);
                if (leaf.accent) {
                    // in which case we do this shit
                    setCurrentLeaf(applyRuleToLeaf(
                        when(ACCENT), leaf, _rules, figureCount));
                }
            } else {
                list.push(leaf);
            }

            // handle "compliment pattern's" rules
            if (_compliment && c_current()) {
                let c_leaf = c_current();

                // next get all rules for the current compliment
                let rules  = getRulesForLeaf(c_leaf, when);
                leaf = rules.reduce(
                    (leaf, rule) => applyRuleToLeaf(rule, leaf, c_rules, figureCount), leaf);

                // then do rules for previous compliment
                if (c_prev()) {
                    rules = getRulesForLeaf(c_prev(), after);
                    leaf = rules.reduce(
                        (leaf, rule) => applyRuleToLeaf(rule, leaf, c_rules), leaf);
                }

                setCurrentLeaf(leaf);
            }

            if (!termOtherwise) {
                // none of the rules applied this turn so lets
                // apply the otherwise condition if it exists
                let rules = [otherwise()];
                leaf = rules.reduce(
                    (leaf, rule) => applyRuleToLeaf(rule, leaf, _rules, figureCount), leaf);
                setCurrentLeaf(leaf);
            }

            prev = leaf;
            nth++;
            figureCount++;
            return leaf;
        };

        const applyDelaysToLeaf = (leaf) => {
            delays.forEach(d => d.delay--);

            let delaysToApply = delays.filter(x => x.delay === 0);
            if (delaysToApply.length > 0) {
                termOtherwise = true;
                leaf = delaysToApply.reduce(
                    (_leaf, action) => applyToLeaf(_leaf, action), leaf);
            }
            return leaf;
        };

        const applyRuleToLeaf = (rule, leaf, rules=_rules, figureCount, isBefore, dontCount) => {
            let {actions, delayedActions, matchedRules} = applyRule(
                rule,
                rules,
                decide,
                figureCount,
                nthFigure,
                totalFigures,
                dontCount);

            delays = [... delays, ...delayedActions];
            if (actions.filter(x => x.type && x.type !== "NOTHING")
                .length > 0 || delayedActions.length > 0) {
                if (!isBefore) {
                    termOtherwise = true;
                }
            }
            let _leaf = actions.reduce(
                    (_leaf, action) => applyToLeaf(_leaf, action), leaf);
            if (!_leaf.rules) {
                _leaf.rules = [];
            }
            if (Array.isArray(_leaf)) {
                _leaf.filter(l => !l.rules).forEach(l => l.rules = []);
            }
            matchedRules.forEach(
                r => 
                    Array.isArray(_leaf) ?
                    _leaf.map(l => l.rules.push(r)) :
                    _leaf.rules.push(r));
            return _leaf;
        };

        const save = () => {
            // saves the current list and clears the list
            // variable so that the same process can occur in
            // nested lists
            let _list = list;
            list = [];
            return _list;
        };

        const restore = (_list) => {
            list = _list;
        };

        const handleArrayLeaf = (leaf) => {
            // leaf is an array so we need to first sav
            let _list = save();
            for (let i=0; i < leaf.length; i++) {
                let _leaf = leaf[i];
                runTerm(_leaf);
            }
            list.cycleLength = leaf.cycleLength;
            _list.push(list);
            restore(_list);
        };

        
        for (let i=0 ; i<_p.length;i++) {
            runTerm(_p[i]);
        }
        lazyValue = list;

        window.nolazies++;
        return lazyValue;
    };
};

// returns any rules might apply to a given leaf, based on the
// predicate type
// for instance, getRulesforLeaf(*leaf w accent*, when) will return
// the rule when(ACCENT)
const getRulesForLeaf = (leaf, predicateType=when) => {
    if (Array.isArray(leaf)) {
        return [predicateType(DOUBLE)];
    }
    let rules = [
        predicateType(ANY)
    ];
    switch (leaf.type.type) {
    case '.':
        rules.push(predicateType(dot()));
        break;
    case "-":
        rules.push(predicateType(dash(leaf.type.value)));
        break;
    }

    if (leaf.accent) {
        rules.push(predicateType(ACCENT));
    }
    
    if (leaf.staccato) {
        rules.push(predicateType(STACCATO));
    }
    if (leaf.legato) {
        rules.push(predicateType(LEGATO));
    }
    if (leaf.pianissimo) {
        rules.push(predicateType(PIANISSIMO));
    }
    if (leaf.flam) {
        rules.push(predicateType(FLAM));
    }
    if (leaf.piano) {
        rules.push(predicateType(PIANO));
    }
    if (leaf.transpose === null) {
        rules.push(predicateType(REST));
    }
    return rules;
};

 

const countFigures = (p) => {
    let lastFigureId = undefined;

    let count=0;
    for (let i=0; i < p.length; i++) {
        let term = p[i];
        if (term.figureId !== lastFigureId) {
            lastFigureId = term.figureId;
            count++;
        }
    }

    return count;
};
